/** @jsx h */
import MapSearchInput from '../Map/MapSearchInput';
import MapFilterFieldset from '../Map/MapFilterFieldset';
import { labels } from '../../config';

const SearchHeaderMap = ({
  query,
  pluginNamespace,
  showFacets,
  facets,
  facetsActive,
  sorting,
  triggerAjaxSubmit,
  searchType,
  showMaininput,
  isReset,
  updateUserCoordinates,
  toggleLoadingAnimation,
  coordinatesApi,
  noCoordinatesFound,
  resetFilters,
}) => {
  return (
    <div className="map__search-wrapper">
      {showFacets &&
        facets.map(
          (facet, index) =>
            facet.type &&
            !facet.hidden && (
              <MapFilterFieldset
                key={index}
                query={query}
                facet={facet}
                facetsActive={facetsActive}
                sorting={sorting}
                triggerAjaxSubmit={triggerAjaxSubmit}
                pluginNamespace={pluginNamespace}
                resetFilters={resetFilters}
                optionsActiveCount={
                  facetsActive?.selected.filter(
                    option => option.name === facet.name
                  ).length
                }
              />
            )
        )}
      {showMaininput && (
        <MapSearchInput
          query={query}
          coordinatesApi={coordinatesApi}
          triggerAjaxSubmit={triggerAjaxSubmit}
          pluginNamespace={pluginNamespace}
          isReset={isReset}
          toggleLoadingAnimation={toggleLoadingAnimation}
          updateUserCoordinates={updateUserCoordinates}
          placeholder={labels.map.placeholder}
          noCoordinatesFound={noCoordinatesFound}
          resetFilters={resetFilters}
        />
      )}
    </div>
  );
};

export default SearchHeaderMap;
